var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ScrollTop',[_c('a',{staticClass:"btn-scroll button-blue-alemana"},[_c('i',{staticClass:"fas fa-chevron-up fa-2x"})])])}
var staticRenderFns = []

export { render, staticRenderFns }